import {
  Card,
  CardContent,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  TextField as MuiTextField,
} from "@mui/material";
import { spacing } from "@mui/system";
import React, { useState } from "react";
import styled from "styled-components";

const Select = styled(MuiSelect)(spacing);
const TextField = styled(MuiTextField)(spacing);

const initialVendor = {
  status: "Active",
  description: "",
};

export default (props) => {
  const handleClose = props.handleClose;
  const submitNewVendor = props.submitNewVendor;

  const [vendorObj, setVendorObj] = useState(initialVendor);

  const onVendorFieldChange = (e) => {
    setVendorObj({ ...vendorObj, [e.target.name]: e.target.value });
  };

  const action = async () => {
    return submitNewVendor(vendorObj);
  };

  return (
    <div>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <h3>Vendor Info:</h3>
            <Grid container item spacing={2}>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Vendor Number"
                  type="text"
                  onChange={onVendorFieldChange}
                  name="vendorNum"
                  required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Vendor Name"
                  type="text"
                  onChange={onVendorFieldChange}
                  name="name"
                  required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Description"
                  type="text"
                  onChange={onVendorFieldChange}
                  name="description"
                  value={vendorObj.description || ""}
                  required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Service Territory"
                  type="text"
                  onChange={onVendorFieldChange}
                  name="serviceTerritory"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Contact Name"
                  type="text"
                  onChange={onVendorFieldChange}
                  name="contactName"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Contact Phone"
                  type="text"
                  onChange={onVendorFieldChange}
                  name="contactPhone"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Contact Email"
                  type="email"
                  onChange={onVendorFieldChange}
                  name="contactEmail"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="SSO Rate Schedule"
                  type="text"
                  onChange={onVendorFieldChange}
                  name="ssoRateSchedule"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="new-vendor-status-label">Status</InputLabel>
                  <Select
                    labelId="new-vendor-status-label"
                    id="new-vendor-status"
                    label="Status"
                    onChange={onVendorFieldChange}
                    value={vendorObj.status || "Active"}
                    name="status"
                  >
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container item spacing={2} justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={async () => {
                    const success = await action();
                    if (success) {
                      handleClose();
                    }
                  }}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};
